import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarDays } from "lucide-react";
import { fmtDateAU, toIso } from "@/lib/format";

export function ExpiryPicker({ date, time, onDate, onTime, min }) {
  return (
    <div className="space-y-2" data-testid="bid-expiry">
      <div className="flex flex-wrap items-center gap-2">
        <DatePickerAU value={date} onChange={onDate} min={min} testid="bid-expiry-date" small />
        <input type="time" value={time} onChange={(e) => onTime(e.target.value)} disabled={!date} data-testid="bid-expiry-time"
          className="h-9 rounded-md border border-input bg-transparent px-3 text-sm disabled:opacity-50" />
        {date && <Button type="button" variant="ghost" size="sm" onClick={() => onDate("")} data-testid="bid-expiry-clear">No expiry</Button>}
      </div>
      <p className="text-xs text-muted-foreground">{date ? "The customer can't accept this bid after this time (your local time)." : "Optional — leave blank and your bid stays open until you withdraw it."}</p>
    </div>
  );
}

export function fmtExpiry(iso) {
  const d = new Date(iso);
  return d.toLocaleString("en-AU", { weekday: "short", day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });
}

export function DatePickerAU({ value, onChange, min, testid = "date-picker", small = false }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;
  const minDate = min ? new Date(`${min}T00:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid={testid} className={`${small ? "h-9 w-40" : "w-full sm:w-64"} justify-start gap-2 font-normal hover:bg-muted hover:text-foreground data-[state=open]:bg-muted data-[state=open]:text-foreground ${value ? "" : "text-muted-foreground"}`}>
          <CalendarDays className="h-4 w-4" /> {value ? fmtDateAU(value) : "dd/mm/yyyy"}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={`${testid}-popover`}>
        {small && value && <button type="button" onClick={() => { onChange(""); setOpen(false); }} className="w-full text-xs text-muted-foreground hover:text-kinetic pt-2" data-testid={`${testid}-clear`}>Clear date</button>}
        <Calendar mode="single" selected={selected} defaultMonth={selected || minDate} weekStartsOn={1}
          disabled={minDate ? { before: minDate } : undefined}
          onSelect={(d) => { if (d) { onChange(toIso(d)); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
